import { Link } from "react-router-dom";
import Button from "@/components/ui/Button";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 text-center">
      <p className="mb-4 font-serif text-8xl text-metro-green-100">404</p>
      <h1 className="mb-3 font-serif text-3xl text-metro-green-950">
        Page not found
      </h1>
      <p className="mb-8 max-w-md text-base text-metro-ink-muted">
        The page you're looking for doesn't exist or may have been moved.
      </p>
      <div className="flex flex-wrap gap-3 justify-center">
        <Link to="/">
          <Button>Back to Home</Button>
        </Link>
        <Link to="/rooms">
          <Button variant="outline">View Rooms</Button>
        </Link>
      </div>
    </div>
  );
}